{
  "es": {
    "ai": {
      "settings": {
        "title": "Configuración de IA",
        "description": "Configuración de las funciones de IA en tu espacio de trabajo.",
        "budget": {
          "title": "Presupuesto mensual",
          "description": "Límite de coste mensual para el uso de IA (fase de prueba). Se recalcula según el uso de tokens en todas las conversaciones de este mes.",
          "budget_label": "Presupuesto",
          "usage_label": "Usado este mes",
          "save": "Guardar"
        }
      },
      "assistant": {
        "name": "Ziggy",
        "all_projects": "Todos los proyectos",
        "empty_state": {
          "title": "¿En qué puedo ayudarte?",
          "subtitle": "Pregúntame lo que quieras sobre tus clientes"
        },
        "suggestions": {
          "open_decisions": "¿Qué decisiones siguen abiertas?",
          "unassigned_units": "¿Qué unidades todavía no tienen cliente?",
          "help_notifications": "¿Cómo configuro las notificaciones?",
          "help_project_settings": "¿Dónde encuentro la configuración del proyecto?"
        },
        "input": {
          "placeholder": "Pregunta sobre tus clientes...",
          "hint": "Intro para enviar · Mayús+Intro para nueva línea",
          "disclaimer": "Los resultados pueden ser inexactos. Verifica siempre la información importante."
        },
        "errors": {
          "generic": "Algo ha salido mal. Inténtalo de nuevo.",
          "budget_reached": "Se ha alcanzado el presupuesto mensual de IA de este espacio de trabajo. Contacta con un administrador para aumentar el límite."
        },
        "cap": {
          "message": "Has alcanzado el límite de conversaciones.",
          "action": "Iniciar una nueva conversación"
        },
        "history": {
          "title": "Conversaciones anteriores",
          "empty": "Todavía no hay conversaciones anteriores"
        },
        "support_cta": {
          "prompt": "¿No es la respuesta que buscabas?",
          "action": "Contactar con soporte"
        }
      }
    }
  }
}
